import { motion } from "framer-motion";

import SectionHeading from "@/components/SectionHeading";
import SmartLink from "@/components/SmartLink";
import { Button } from "@/components/ui/button";
import { iconRegistry } from "@/content/iconRegistry";

export default function ProfileSection({ content, dataTestId, className = "" }) {
  const Icon = iconRegistry[content.icon];
  const descriptionParagraphs = content.description
    ? content.description.split("\n\n").map((item) => item.trim()).filter(Boolean)
    : [];

  return (
    <section className={`py-16 md:py-24 bg-muted/50 ${className}`.trim()} data-testid={dataTestId}>
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <SectionHeading title={content.title} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="bg-card rounded-3xl p-8 md:p-12 shadow-soft border border-border"
        >
          <div className="flex flex-col md:flex-row items-center gap-8">
            {content.imageSrc ? (
              <img
                src={content.imageSrc}
                alt={content.imageAlt || content.name}
                className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover flex-shrink-0 shadow-soft"
              />
            ) : (
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-gradient-to-br from-secondary/92 to-secondary/72 flex items-center justify-center flex-shrink-0 border border-white/10">
                <Icon className="w-16 h-16 text-highlight/85" />
              </div>
            )}
            <div className="text-center md:text-left">
              <h3 className="font-sans text-2xl font-bold text-foreground mb-2">{content.name}</h3>
              <p className="font-body text-highlight font-medium mb-4">{content.role}</p>
              <div className="font-body text-muted-foreground leading-relaxed space-y-3">
                {descriptionParagraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
              {content.cta ? (
                <Button asChild className="mt-6 rounded-full bg-secondary hover:bg-secondary/85 text-white font-medium px-6 btn-hover">
                  <SmartLink href={content.cta.href} external={content.cta.external}>
                    {content.cta.label}
                  </SmartLink>
                </Button>
              ) : null}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
